import React from "react"
import { site } from "../../../../../utils/site"
import Section from "../../../../core/layout/main/section/Section"
import * as TitleTextButton from "./TitleTextButtonSection.module.scss"
import CtaLink from "../../../../core/cta-link/CtaLink"

function TitleTextButtonSection({ title, text, buttonCtaLink, buttonTitle }) {
  return (
    <Section
      className={`pbl-6 mb-6 ${site === "blog" ? "pin-0" : ""}`}
      container={site === "blog" ? "fluid" : "xxlarge"}
    >
      <div
        className={`${
          site === "rh"
            ? "large quartary-background-color"
            : "large secondary-background-color"
        } p-6 fade-in-bottom ${
          site === "rh" ? TitleTextButton.Rh : TitleTextButton.Blog
        }`}
      >
        <div>
          <h2 className="pb-3">{title}</h2>
          <p>{text}</p>
        </div>
        <div
          className={`${TitleTextButton.btn} mt-2 mt-lg-2 ${
            site === "rh" ? "ml-lg-auto" : "mt-lg-4"
          } `}
        >
          <CtaLink ctaLink={buttonCtaLink}>{buttonTitle}</CtaLink>
        </div>
      </div>
    </Section>
  )
}

export const name = "TitleTextButton"

export const init = (componentData) => {
  return (
    <TitleTextButtonSection
      key={componentData.id}
      title={componentData.label}
      text={componentData.text}
      buttonTitle={componentData.buttonLabel}
      buttonCtaLink={componentData.buttonCtaLink}
    />
  )
}

export default TitleTextButtonSection
